import type { HTMLAttributes } from "react";
import { cn } from "@shared/lib/utils";

type GlassPanelProps = HTMLAttributes<HTMLDivElement> & {
  /** Adds hairline-brighten + background nudge + 1px lift on hover. */
  hover?: boolean;
};

/**
 * Standard TycoonEX surface — every panel in the app starts here.
 * Flat card: #ffffff08 fill + 1px hairline, no blur, no glow.
 * Default radius comes from .ty-card (16px); pass rounded-* to override.
 */
export function GlassPanel({ hover = false, className, children, ...rest }: GlassPanelProps) {
  return (
    <div className={cn("ty-card", hover && "ty-card-hover", className)} {...rest}>
      {children}
    </div>
  );
}
